import {QueryKeys} from '../../../queryDefaults/QueryKeys';
import {useHighFrequencyRefreshQuery} from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import {PatientInvitations} from '../PatientInvitations.ts';
import {PatientInvitationsApi} from '../../../apis/PatientInvitationsApi/PatientInvitationsApi.ts';

export function useGetPatientInvitationsByToken(token: string, enabled: boolean = true) {
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.patientInvitations, token],
        queryFn: async () => {
            const result = await PatientInvitationsApi.getPatientInvitations(token, true);
            return result ? new PatientInvitations(result) : result;
        },
        enabled: !!token && enabled,
        retry: false,
    });
}
